import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Label, ModuleFE_Thunderstorm } from '@nu-art/thunderstorm-frontend/index';
const renderTreeNode_CheckedItem = (props, map) => {
    const crItem = map[props.item.dbKey];
    let content;
    if (!crItem || !props.item.item)
        content = props.item.itemId;
    else
        content = crItem.renderer(props.item.item) ?? props.item.itemId;
    return _jsx(Label, { className: 'conflict-resolution-tree__checked-item', tooltip: content, children: content });
};
const renderTreeNode_ConflictingCollection = (props, map) => {
    const crItem = map[props.item.dbKey];
    if (!crItem)
        return _jsx(_Fragment, { children: props.item.dbKey });
    return _jsx(_Fragment, { children: crItem.collectionRenderer(props.item.dbKey) });
};
const renderTreeNode_ConflictingItem = (props, map) => {
    const crItem = map[props.item.dbKey];
    let content;
    if (!crItem || !props.item.item)
        content = props.item.itemId;
    else
        content = crItem.renderer(props.item.item) ?? props.item.itemId;
    return _jsx(Label, { className: 'conflict-resolution-tree__conflicting-item', tooltip: content, onClick: () => ModuleFE_Thunderstorm.copyToClipboard(props.item.itemId), children: content });
};
export const ConflictResolutionTreeRenderers = (map) => ({
    root: () => _jsx(_Fragment, {}),
    checkedItem: (props) => renderTreeNode_CheckedItem(props, map),
    conflictingCollection: (props) => renderTreeNode_ConflictingCollection(props, map),
    conflictingItem: (props) => renderTreeNode_ConflictingItem(props, map),
});
//# sourceMappingURL=tree-rendering.js.map